import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styles from "./SignInView.module.css";
import jsQR from "jsqr"

export function SignInView() {

    const canvasRef = useRef<HTMLCanvasElement>(null);
    const canvasContext = useRef<CanvasRenderingContext2D>();

    const videoRef = useRef<HTMLVideoElement>(null);
    const cameraStream = useRef<MediaStream>();
    const lastFrameReq = useRef<number>(-1)
    
    const [isSigningIn, setSigningIn] = useState(false);
    const [isRecording, setRecording] = useState(false);

    const history = useHistory();

    useEffect(() => {
        canvasContext.current = canvasRef.current!.getContext("2d")!;
    }, [canvasRef]);

    useEffect(() => {
        return () => {
            if(cameraStream.current) {
                cameraStream.current.getTracks().forEach(track => {
                    track.stop();
                })
            }
            if(lastFrameReq.current >= 0) {
                cancelAnimationFrame(lastFrameReq.current);
            }
        }
    }, []);

    const startSignIn = (userId: string) => {
        setSigningIn(true);
        setTimeout(() => {
            setSigningIn(false);
            setRecording(false);
            history.push(`/${userId}/notes`)
        }, 2000)
    };


    const tick = () => {
        const video = videoRef.current!;
        const canvas = canvasRef.current!;
        const context = canvasContext.current!;
        if(video && canvas && video.readyState === video.HAVE_ENOUGH_DATA) {
            canvas.height = video.videoHeight;
            canvas.width = video.videoWidth;

            context.drawImage(video, 0,0, canvas.width, canvas.height);
            const imageData = context.getImageData(0,0,canvas.width, canvas.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height, {
                inversionAttempts: "dontInvert"
            });
            if(code) {
                startSignIn(code.data);
            }
        }
        lastFrameReq.current = requestAnimationFrame(tick)
    }

    const startFeedback = () => {
        navigator.mediaDevices.getUserMedia({ video: { 
            facingMode: "environment", 
            width: 640, 
            height: 480 }
        }).then(stream => {
            videoRef.current!.srcObject = stream;
            videoRef.current!.setAttribute("playsinline", "true");
            videoRef.current!.play();
            cameraStream.current = stream;
            setRecording(true);
            setTimeout(() => {
                lastFrameReq.current = requestAnimationFrame(tick);
            }, 100)
        })
    }

    return (
        <div className={ styles.container }>
            <div className={ styles.mainPanel }>
                <h1>SecureNotes</h1>
                <p>
                    <span>Want to make an account?</span>
                    <Link to="/register">Register</Link>
                </p>

                <div className={ styles.videoContainer }>
                    {
                        !isRecording && !isSigningIn && (
                            <button onClick={ startFeedback }>Sign in with a QR Code</button>
                        )
                    }
                    <video ref={ videoRef }>
                    </video>
                    <canvas ref={ canvasRef } style={{ display: "none" }} />
                    <div className={ `${styles.signInSuccess} ${ !isSigningIn ? styles.hidden : ""}` }>
                        Success!
                    </div>
                </div>
                <form onSubmit={ (e) => { e.preventDefault(); startSignIn(e.currentTarget.querySelector("input")!.value) }}>
                    <label>Have a text code? Enter it here:
                        <input placeholder="abcd-asdk-1234-asda" />
                    </label>
                </form>
            </div>
        </div>
    )
}